export default __webpack_public_path__ + "static/media/sec3.a85e3ee9.png";